export enum Period {
    none = 0,
    today = 1,
    yesterday = 2,
    currentMonth = 3,
    last7Days = 4,
    last30Days = 5,
    last90Days = 6,
    last180Days = 7,
    currentYear = 8,
    previousYear = 9
}